export default "__VITE_ASSET__Ds$sF2Dg__"